import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history', // 默认的hash模式会使得url带# 
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      redirect: '/home'
    }, {
      path: '/home',
      name: 'home',
      component: resolve => require(['@/view/Home'], resolve),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/company/lsjz',
      name: 'lsjz',
      component: resolve => require(['@/view/Lsjz'], resolve),
      meta: {
        title: '公司介绍丨联盛浆纸'
      }

    },
    {
      path: '/company/lszy',
      name: 'lszy',
      component: resolve => require(['@/view/Lszy'], resolve),
      meta: {
        title: '公司介绍丨联盛纸业'
      }
    },
    {
      path: '/about/memorabilia',
      name: 'memorabilia',
      component: resolve => require(['@/view/about/Memorabilia'], resolve),
      meta: {
        title: '关于丨大事记'
      }
    },
    {
      path: '/about/qualification',
      name: 'qualification',
      component: resolve => require(['@/view/about/Qualification'], resolve),
      meta: {
        title: '关于丨资质荣誉'
      }
    },
    {
      path: '/value/corporateculture',
      name: 'corporateculture',
      component: resolve => require(['@/view/value/CorporateCulture'], resolve),
      meta: {
        title: '企业价值丨企业文化'
      }
    },
    {
      path: '/value/managesystem',
      name: 'managesystem',
      component: resolve => require(['@/view/value/ManageSystem'], resolve),
      meta: {
        title: '企业价值丨管理体系'
      }
    },
    {
      path: '/value/certifaccred',
      name: 'certifaccred',
      component: resolve => require(['@/view/value/CertifAccred'], resolve),
      meta: {
        title: '企业价值丨认证认可'
      }
    },
    {
      path: '/infor/companynews',
      name: 'companynews',
      component: resolve => require(['@/view/infor/CompanyNews'], resolve),
      meta: {
        title: '资讯中心丨公司动态'
      }
    },
    {
      path: '/infor/mediafocus',
      name: 'mediafocus',
      component: resolve => require(['@/view/infor/MediaFocus'], resolve),
      meta: {
        title: '资讯中心丨媒体聚集'
      }
    },
    {
      path: '/infor/investment',
      name: 'investment',
      component: resolve => require(['@/view/infor/Investment'], resolve),
      meta: {
        title: '资讯中心丨招采信息'
      }
    },
    {
      path: '/sustainable/socialresp',
      name: 'socialresp',
      component: resolve => require(['@/view/sustainable/SocialResp'], resolve),
      meta: {
        title: '可持续发展丨社会责任'
      }
    },
    {
      path: '/sustainable/envirpro',
      name: 'envirpro',
      component: resolve => require(['@/view/sustainable/EnvirPro'], resolve),
      meta: {
        title: '可持续发展丨安全环保'
      }
    },
    {
      path: '/sustainable/energysave',
      name: 'energysave',
      component: resolve => require(['@/view/sustainable/EnergySave'], resolve),
      meta: {
        title: '可持续发展丨节能低碳'
      }
    },
    {
      path: '/sustainable/cleaner',
      name: 'cleaner',
      component: resolve => require(['@/view/sustainable/Cleaner'], resolve),
      meta: {
        title: '可持续发展丨清洁生产'
      }
    },
    {
      path: '/marketing/prodintro',
      name: 'prodintro',
      component: resolve => require(['@/view/marketing/ProdIntro'], resolve),
      meta: {
        title: '产品营销丨产品介绍'
      }
    },
    {
      path: '/marketing/marketnet',
      name: 'marketnet',
      component: resolve => require(['@/view/marketing/MarketNet'], resolve),
      meta: {
        title: '产品营销丨营销网络'
      }
    },
    {
      path: '/marketing/warehouselogistics',
      name: 'warehouselogistics',
      component: resolve => require(['@/view/marketing/WarehouseLogistics'], resolve),
      meta: {
        title: '产品营销丨仓储物流'
      }
    },
    {
      path: '/marketing/contractmsg',
      name: 'contractmsg',
      component: resolve => require(['@/view/marketing/ContractMsg'], resolve),
      meta: {
        title: '产品营销丨联系留言'
      }
    },
    {
      path: '/recruitment/talentconcept',
      name: 'talentconcept',
      component: resolve => require(['@/view/recruitment/TalentConcept'], resolve),
      meta: {
        title: '人才招募丨人才理念'
      }
    },
    {
      path: '/recruitment/harmonyhome',
      name: 'harmonyhome',
      component: resolve => require(['@/view/recruitment/HarmonyHome'], resolve),
      meta: {
        title: '人才招募丨和谐家园'
      }
    },
    {
      path: '/recruitment/recruitinfo',
      name: 'recruitinfo',
      component: resolve => require(['@/view/recruitment/RecruitInfo'], resolve),
      meta: {
        title: '人才招募丨招聘信息'
      }
    },
    {
      path: '/recruitment/contactus',
      name: 'contactus',
      component: resolve => require(['@/view/recruitment/ContactUs'], resolve),
      meta: {
        title: '人才招募丨联系我们'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js